import { t as e } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import t from "../text/text.js";
import { Fragment as n, createBlock as r, createCommentVNode as i, createElementBlock as a, createElementVNode as o, normalizeClass as s, openBlock as c, renderList as l, resolveComponent as u, resolveDynamicComponent as d, toDisplayString as f, withCtx as p } from "vue";
import { DtIconArrowDown as m, DtIconArrowLeft as h, DtIconArrowRight as g, DtIconArrowUp as _, DtIconCommand as v, DtIconLayoutGrid as y, DtIconOption as b, DtIconPlus as x } from "@dialpad/dialtone-icons/vue";
//#region components/keyboard_shortcut/keyboard_shortcut.vue
var S = {
	"{win}": y,
	"{arrow-right}": g,
	"{arrow-left}": h,
	"{arrow-up}": _,
	"{arrow-down}": m,
	"{cmd}": v,
	"{opt}": b
}, C = {
	"{cmd}": "Command",
	"{opt}": "Option",
	"{win}": "Windows",
	"{arrow-right}": "Right Arrow",
	"{arrow-left}": "Left Arrow",
	"{arrow-up}": "Up Arrow",
	"{arrow-down}": "Down Arrow",
	"{plus}": "plus"
}, w = {
	ctrl: "Control",
	alt: "Alt",
	esc: "Escape",
	del: "Delete",
	ins: "Insert",
	pgup: "Page Up",
	pgdn: "Page Down",
	num: "Number",
	caps: "Caps Lock"
}, T = {
	compatConfig: { MODE: 3 },
	name: "DtKeyboardShortcut",
	components: {
		DtIconLayoutGrid: y,
		DtIconArrowRight: g,
		DtIconArrowLeft: h,
		DtIconArrowUp: _,
		DtIconArrowDown: m,
		DtIconCommand: v,
		DtIconOption: b,
		DtIconPlus: x,
		DtText: t
	},
	props: {
		inverted: {
			type: Boolean,
			default: !1
		},
		shortcut: {
			type: String,
			required: !0
		},
		screenReaderText: {
			type: String,
			default: null
		}
	},
	data() {
		return { separator: /\+/gi };
	},
	computed: {
		icons() {
			return {
				...S,
				"{plus}": x
			};
		},
		shortcutWithSeparator() {
			return this.shortcut.replace(this.separator, "{plus}");
		},
		formattedShortcut() {
			return Object.keys(S).reduce((e, t) => e.replace(RegExp("{" + t + "}", "gi"), S[t]), this.shortcutWithSeparator);
		},
		formattedShortcutSplit() {
			let e = Object.keys(this.icons).join("|"), t = RegExp(`(${e})`, "gi");
			return this.formattedShortcut.split(t).filter(Boolean);
		},
		generatedScreenReaderText() {
			return this.formattedShortcutSplit.map((e) => {
				let t = e.trim();
				if (C[t]) return C[t];
				let n = t.toLowerCase();
				return w[n] ? w[n] : t;
			}).filter((e) => e).join(" ");
		}
	}
}, E = { class: "d-keyboard-shortcut--sr-only" }, D = ["innerHTML"];
function O(e, t, m, h, g, _) {
	let v = u("dt-text");
	return c(), a("kbd", { class: s(["d-keyboard-shortcut", { "d-keyboard-shortcut--inverted": m.inverted }]) }, [o("span", E, f(m.screenReaderText || _.generatedScreenReaderText), 1), (c(!0), a(n, null, l(_.formattedShortcutSplit, (e, t) => (c(), a(n, null, [_.icons[e] ? (c(), r(d(_.icons[e]), {
		key: `icon-${t}-${e}`,
		size: "100",
		"aria-hidden": "true",
		class: s(["d-keyboard-shortcut__icon", { "d-keyboard-shortcut__icon--inverted": m.inverted }])
	}, null, 8, ["class"])) : e.trim() ? (c(), r(v, {
		key: `text-${t}-${e}`,
		kind: "body",
		size: 200,
		numeric: "",
		density: 400,
		tone: "tertiary",
		"aria-hidden": "true",
		class: s(["d-keyboard-shortcut__item", { "d-keyboard-shortcut__item--inverted": m.inverted }])
	}, {
		default: p(() => [o("span", { innerHTML: e }, null, 8, D)]),
		_: 2
	}, 1032, ["class"])) : i("", !0)], 64))), 256))], 2);
}
var k = /* @__PURE__ */ e(T, [["render", O]]);
//#endregion
export { k as default };

//# sourceMappingURL=keyboard-shortcut.js.map